import type { CustomFieldDef } from "#app/components/custom-fields/types";
import { useWorkspaceData } from "#app/lib/data/workspace-data-provider";

/**
 * Every workspace custom-field definition, as a stable array — the board-level
 * read behind the kanban cards' field tokens and the Customize view popover
 * (ONE read at the board level, never per card). Reads the workspace data
 * provider, which already holds the list; never re-queries.
 */
export function useAllCustomFields(): CustomFieldDef[] {
  return useWorkspaceData().customFields;
}
